export const actionTypes = {
    fetchOrders: 'FETCH_ORDERS',
    receiveOrders: 'RECEIVE_ORDERS',
    updateOrder:'UPDATE_ORDER',
    clearOrders : 'CLEAR_ORDERS'
};

export const clearOrders = { type: actionTypes.clearOrders };

